import { handleActions } from 'redux-actions'
import update from 'immutability-helper'

import {
  SET_ALERT,
  CLEAR_ALERT,
  CLEAR_ALL_ALERTS
} from '../actions/alerts'

export default handleActions({
  [SET_ALERT]: (state, action) => {
    const { message, link, type, status } = action.payload

    return update(state, {$push: [{message, link, type, status}]})
  },
  [CLEAR_ALERT]: (state, action) => {
    const { index } = action.payload

    return update(state, {
      [index]: {
        $merge: {status: 'resolved'}
      }
    })
  },
  [CLEAR_ALL_ALERTS]: (state, action) => ([])
}, [])



// WEBPACK FOOTER //
// ./src/reducers/alerts.js